// This is just an example,
// so you can safely delete all default props below

export default {
  menu: {
    home: 'Home',
    settings: 'Settings'
  },
  failed: 'Action failed',
  success: 'Action was successful'
};
